import { useEffect } from 'react';

// material-ui
import {
  Box,
  Grid,
  Typography,
  LinearProgress
} from '@mui/material';

// project import
import NotificationItem from './NotificationItem';

// store
import useNotificationsStore from './notificationsStore';

// api
import { useApiGeneric } from 'pages/content/api/api-generic';

const NotificationsList = () => {
  const { fetchAPI } = useApiGeneric();

  const notifications = useNotificationsStore(state => state.notifications);
  const isLoading = useNotificationsStore(state => state.isLoading);
  const fetchNotifications = useNotificationsStore(state => state.fetchNotifications);

  // Fetch the list via GetList when the popup opens (component mounts).
  useEffect(() => {
    fetchNotifications(fetchAPI);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box>
      {isLoading && <LinearProgress sx={{ mb: 1 }} />}

      {!isLoading && notifications.length === 0 && (
        <Typography variant="body2" color="text.secondary" sx={{ py: 2, textAlign: 'center' }}>
          No tienes notificaciones pendientes
        </Typography>
      )}

      {notifications.length > 0 && (
        // Every notification renders as its own capsule, no wrapper capsule.
        <Grid container spacing={1} alignItems="stretch">
          {notifications.map((notification) => (
            <Grid key={notification.id} item xs={12} sx={{ display: 'flex' }}>
              <NotificationItem notification={notification} />
            </Grid>
          ))}
        </Grid>
      )}
    </Box>
  );
};

export default NotificationsList;
